<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-form v-bind="this.$attrs" ref="form">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>ĐỔI MẬT KHẨU</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text class="px-6 pt-6 pb-0">
          <v-text-field
            label="Mật khẩu cũ"
            v-model="oldPassword"
            :type="showOldPassword ? 'text' : 'password'"
            :append-icon="showOldPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showOldPassword = !showOldPassword"
            outlined
            required
            class="required"
            :rules="[$rules.nospace, $rules.minLength(6), $rules.required]"
          ></v-text-field>

          <v-text-field
            label="Mật khẩu mới"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showPassword = !showPassword"
            outlined
            required
            class="required"
            :rules="[$rules.nospace, $rules.minLength(6), $rules.required]"
          ></v-text-field>

          <v-text-field
            label="Nhập lại mật khẩu"
            v-model="password2"
            :type="showPassword2 ? 'text' : 'password'"
            :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showPassword2 = !showPassword2"
            required
            :rules="[$rules.nospace, $rules.minLength(6), $rules.passInputAgain(password2, password)]"
            outlined
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-6">
          <v-btn color="blue darken-4" outlined @click="closeDialog">Hủy </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      oldPassword: '',
      password: '',
      password2: '',
      showOldPassword: false,
      showPassword: false,
      showPassword2: false,
      statusOptions: [
        { label: 'Đang hoạt động', value: 'false' },
        { label: 'Đã bị khóa', value: 'true' }
      ]
    }
  },
  methods: {
    ...mapActions('user', ['generateUserName', 'changePassword']),

    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const data = {
          userId: this.user._id,
          oldPassword: this.oldPassword,
          newPassword: this.password
        }
        try {
          await this.changePassword(data)
          this.$alert.success('Đổi mật khẩu thành công')
          this.closeDialog()
        } catch (e) {
          console.log(e)
        }

        this.$loading.active = false
      }
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
